module.exports = __webpack_public_path__ + "img/jinrong.5352f3c5.jpg";